import SchemaTyped from "rsuite/esm/Schema/Schema";
import { convertSnakeCaseToCamelCase, objectHasProperty } from "./utils";
import { websitePattern } from "./regex";
import { cloneDeep } from 'lodash';

const {
    StringType,
    BooleanType,
} = SchemaTyped.Types;

export const validationNameRegex = /^(?![ -])[A-Za-z\s-]+$/
export const validationLetterNumberMixRegex = /^(?![ -])(?=.*[A-Za-z])(?=.*[0-9])?[A-Za-z0-9\s-]+$/
export const validationLetterNumberHyphenMixRegex = /^(?![ _-])(?=.*[A-Za-z])(?=.*[0-9])?[A-Za-z0-9\s-]+$/;// Only letters or letters+hyphens
export const validationCompanyNameRegex = /^[.@&]?[a-zA-Z0-9 ]+[ !.@&()-]?[ a-zA-Z0-9!()-]+/;

export const stringValidation = StringType()
export const nameValidation = StringType().pattern(validationNameRegex, "May contain only letters, spaces and/or hyphens.");
export const nameRequiredValidation = StringType().pattern(validationNameRegex, "May contain only letters, spaces and/or hyphens.").isRequired("This field is required");
export const companyNameValidation = StringType().pattern(validationCompanyNameRegex, "Company names must begin with ., @, & or an alphanumeric character.  The remainder of the name may only include -, !, ., @, &, (, ), alphanumeric characters or a single space character.");
export const companyNameRequiredValidation = StringType().pattern(validationCompanyNameRegex, "Company names must begin with ., @, & or an alphanumeric character.  The remainder of the name may only include -, !, ., @, &, (, ), alphanumeric characters or a single space character.").isRequired("This field is required");
export const emailValidation = StringType().isEmail();
export const emailRequiredValidation = StringType().isEmail("Invalid email address.").isRequired("This field is required");
export const phoneValidation = StringType().pattern(/^\d{10}$/, "A 10 digit phone number is required");
export const phoneRequiredValidation = StringType().pattern(/^\d{10}$/, "A 10 digit phone number is required").isRequired("This field is required");
export const phoneMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
export const requiredValidation = StringType().isRequired("This field is required");
export const requiredBooleanValidation = BooleanType().isRequired("This field is required");
// Should match with or without http or https
// - https://test.com
// - https://www.test.com
// - https://www.test.com/
// - https://www.test.com/aaa
// - https://www.test.com/aaa/bbb.html
// - www.test.com/aaa/bbb.html
// - test.com/aaa/bbb.html
// - etc
export const urlValidation = StringType().addRule((value, _data) => {return websitePattern.test(value)})
export const urlRequiredValidation = StringType().addRule((value, _data) => {return websitePattern.test(value)}).isRequired("This field is required");
export const checkedValidation = BooleanType().addRule((value, _data) => {
    return value === true
})

export const getFlowFormValidationRuleWithRequirement = (propertyName, configOptions, validationRule) => {
    let parsedOptions = {};
    Object.keys(configOptions).forEach(key => {
        let parsedKey = convertSnakeCaseToCamelCase(key);
        parsedOptions[parsedKey] = configOptions[key];
    });
    
    let isOptional = false;
    if (objectHasProperty(propertyName, parsedOptions)) {
        isOptional = parsedOptions[propertyName] === "optional";
    }
    
    let coreRule = cloneDeep(validationRule);
    if (isOptional) {
        coreRule.emptyAllowed = true;
        coreRule.required = false;
    }
    if (!isOptional) {
        coreRule = coreRule.isRequired("This is a required field");
    }
    return coreRule;

}